import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { functions } from "../api/firebase";
import { httpsCallable } from "firebase/functions";
import { addNotification } from "./notificationSlice";

const sendEmailFunction = httpsCallable(functions, "sendPublicContactEmail");

// --- CORRECCIÓN ---
// El thunk ahora espera un único objeto 'payload' que contiene todos los datos necesarios.
// Este es el formato que la Cloud Function espera.
export const submitContactForm = createAsyncThunk(
  "contactForm/submit",
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      const result = await sendEmailFunction(payload);

      if (result.data.success) {
        dispatch(
          addNotification({
            type: "success",
            message: "¡Mensaje enviado con éxito! Gracias por contactarnos.",
          })
        );
        return true;
      } else {
        throw new Error(
          result.data.message || "Ocurrió un error en el servidor."
        );
      }
    } catch (e) {
      // El middleware de errores se encargará de mostrar la notificación
      return rejectWithValue(e.message);
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  success: false,
};

const contactFormSlice = createSlice({
  name: "contactForm",
  initialState,
  reducers: {
    resetFormStatus: (state) => {
      state.success = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitContactForm.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(submitContactForm.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(submitContactForm.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetFormStatus } = contactFormSlice.actions;
export default contactFormSlice.reducer;
